import { render } from "./AskQuestionModal.vue?vue&type=template&id=1258e936&scoped=true"
import script from "./AskQuestionModal.vue?vue&type=script&lang=js"
export * from "./AskQuestionModal.vue?vue&type=script&lang=js"

import "./AskQuestionModal.vue?vue&type=style&index=0&id=1258e936&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1258e936"]])

export default __exports__